module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch01_hd",
      "role": "doc-chapter"
    }
  }, [_c('h2', {
    staticClass: "h2chap",
    attrs: {
      "id": "ch01_hd"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 16",
      "id": "page_16",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("CHAPTER 1 "), _c('span', {
    staticClass: "heading_break1"
  }, [_vm._v("YOUR PLUMBING, FROM GUT TO BUTT")])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote1"
  }, [_c('p', {
    staticClass: "quote"
  }, [_vm._v("“Should I refuse a good dinner simply because I do not understand the process of digestion?”")]), _vm._v(" "), _c('p', {
    staticClass: "quoteatt"
  }, [_vm._v("—Oliver Heaviside"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042845/xhtml/#footnote-023",
      "id": "footnote-023-backlink"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "st-head"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("ELLA’S STORY:")]), _vm._v(" DOING ALL THE WRONG THINGS")]), _vm._v(" "), _c('p', {
    staticClass: "st-para"
  }, [_vm._v("Ella, a single, thirty-something, stressed-out, multitasking manager of a software start-up, wakes up with a jolt, looks at her phone, and realizes she has overslept. It is Wednesday, and today of all days, she can’t be late for work since she’s in charge of a team meeting. She throws on her clothes, drags a comb through her tangled hair, and heads for the "), _c('span', {
    attrs: {
      "aria-label": "page 17",
      "id": "page_17",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("kitchen. Once in the kitchen, she grabs the large cinnamon roll her coworker gave her yesterday at work, nukes it, then ferociously attacks it. She washes down the sweet, doughy mixture in her mouth with a cup of day-old coffee she didn’t even bother to heat, grabs her coat and purse, rushes out the door and off to work.")])]), _vm._v(" "), _c('p', {
    staticClass: "st-para"
  }, [_vm._v("Ella is lucky that the traffic isn’t snarled, so she arrives with six minutes to spare. Once at work, she immediately heads to the employee lounge, pours herself a 32-ounce cup of hot black coffee and heads to the conference room for the meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "st-para"
  }, [_vm._v("The meeting goes swimmingly.")]), _vm._v(" "), _c('p', {
    staticClass: "st-para"
  }, [_vm._v("But now, with a ton of tasks to finish before the day ends, Ella knocks back the rest of her coffee. By 11:00 a.m. she feels the heartburn creeping up her throat, so she pops a couple of chewable antacids and gets back to work. Since there’s so much on her plate today, Ella skips lunch to keep up with the day’s to-do list. She finally takes a short break around 3:00 p.m. There are a couple of large slices of pepperoni pizza in a box sitting on the counter in the lounge, so she picks one up and quickly gobbles it down cold, chasing it with yet another large cup of black coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "st-para"
  }, [_vm._v("Since she stayed focused and completed her tasks for the day, Ella is able to leave work at 5:00 p.m. for a change. It isn’t until she gets home that she realizes her stomach is "), _c('span', {
    attrs: {
      "aria-label": "page 18",
      "id": "page_18",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("rumbling. This leads her to a further realization: although she peed several times, she hasn’t pooped all day. Not one to let little things like the lack of a bowel movement or a mild tummy ache bother her, she heads to the gym and works out for almost an hour.")])]), _vm._v(" "), _c('p', {
    staticClass: "st-para"
  }, [_vm._v("After her workout, Ella finally feels like she might be able to poop. She gets situated on the toilet and waits a couple of minutes. When nothing happens, she pushes hard to get the process going. When just a few small, round turds plop into the water, she sighs, then pushes harder to try to open the poop gates. More small turds come out. Eventually, Ella decides she has pooped enough, so she vigorously wipes her butt until there’s a little blood mixed with the poop on the toilet paper, which is normal for her.")]), _vm._v(" "), _c('p', {
    staticClass: "st-para"
  }, [_vm._v("After a well-deserved hot shower, Ella orders dinner through Uber Eats. When it arrives, the aroma wafting from the exquisitely textured lasagna, antipasto, breadsticks, and marinara sauce tantalizes Ella’s senses. She pours a glass of cabernet sauvignon and digs in. After the main course, she eats a slice of New York–style cheesecake. Ella has eaten so much that she feels more stuffed than she has in a very long time. She smiles to herself at what a great day she had! But before calling it a night, she impulsively decides to binge-watch a series that everyone is talking about at work. By the time she finishes, it is 1:00 a.m. As she performs her nightly routine "), _c('span', {
    attrs: {
      "aria-label": "page 19",
      "id": "page_19",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("before bed, she feels the acid rising up her throat again, but this time the heartburn is more intense. Ella takes three antacids and goes to bed.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3x",
    attrs: {
      "id": "lev01"
    }
  }, [_vm._v("WHAT WENT WRONG?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ella’s story, though fictional, mimics that of thousands of real-life people I’ve seen over the course of my career as the “Rear Admiral.” Ella thinks she had a great day, but let’s explore where that isn’t true. For starters, she is stressed out from oversleeping, which has her nerve endings frayed. The half-chewed, fiberless, high-fat, empty-calorie sweet roll goes down her throat as a lump of dough and sugar while the coffee acts as a bladder irritant, removing water from her body via her frequent pee breaks. The result is dehydration.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After Ella’s day of poor eating and drinking, she suffers the consequences of her actions. Hard-charging, type-A Ella is "), _c('i', [_vm._v("constipated")]), _vm._v("! Too much coffee, cold pizza, and later, more fiberless, high-fat food with dehydrating alcohol created heartburn twice because of their acidic qualities and her lack of hydration. The antacids act only as temporary Band-Aids masking the symptoms of her heartburn. Her grumbling stomach is another sign that Ella’s gut is out of whack. The dehydration withdraws water from her colon (large intestine), making the stools hard and dry.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 20",
      "id": "page_20",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("She makes things worse by pushing and straining to poop (this is very bad, by the way) for a small yield of a few hard, dry popcorn turds, followed by obsessive wiping (which is also bad), until she draws blood from her abused anus. Ella, in turn, doesn’t get enough sleep. Sleep would help her body recharge as well as protect her from disease.")])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781646042845/images/f0020-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sb-head"
  }, [_vm._v("BUTTY’S SIDENOTE")]), _vm._v(" "), _c('p', {
    staticClass: "sb-para"
  }, [_vm._v("For those of us who consume fiber-rich foods and drink plenty of water, one cup of coffee in the morning can stimulate the smooth muscles of the large intestine to facilitate your first poop of the day. If your daily regimen consists of limited amounts of fiber and water plus several cups of strong coffee, you may very well end up with lots of pee breaks, few, if any, poops, and the caffeine jitters to boot.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now, let’s not get all bound up with constipation (pun intended) right now; in later chapters, I plan to delve deeper into constipation, along with other related issues like dehydration and fiberless foods. But for now, whether you realized it before or "), _c('span', {
    attrs: {
      "aria-label": "page 21",
      "id": "page_21",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("not, you can see that understanding the power of pooping could truly change Ella’s (and your) life!")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3x",
    attrs: {
      "id": "lev02"
    }
  }, [_vm._v("THE POWER OF POOPING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When most people put food or drink in their mouths, they are clueless about the magic or, in Ella’s case, the mayhem, that can happen as it slides down the esophagus to the stomach, traverses 30 feet of small and large intestines to the poop chute, the rectum, and out of the anus after twenty-four to forty hours. As the late motivational speaker Jim Rohn once said, “Treat your body like a temple, not a woodshed. The mind and body work together. Your body needs to be a good support system for the mind and spirit.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042845/xhtml/#footnote-022",
      "id": "footnote-022-backlink"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I firmly believe that if people understood the basic anatomy and function of the components in their digestive system, they would not treat their bodies like a woodshed but with more love, kindness, and respect. When I’m working in the clinic, I often explain to my patients that the digestive system is truly an intricately designed network of plumbing that only works well when it isn’t clogged with an accumulation of cluttered waste. My job is to act as the master plumber to help them become mindful enough of the digestive process to make positive "), _c('span', {
    attrs: {
      "aria-label": "page 22",
      "id": "page_22",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("changes to their diets and lifestyles. Only then can they fully realize the true power of pooping!")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3x",
    attrs: {
      "id": "lev03"
    }
  }, [_vm._v("WHAT IS THE DIGESTIVE SYSTEM?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now, let’s take the plunge to plumb the depths of your plumbing. As the supersleuth Sherlock Holmes might say, “It’s ‘alimentary,’ my dear Watson.” The alimentary or gastrointestinal tract (GI, for short) includes the mouth, throat, esophagus, stomach, small intestine, large intestine, rectum, and anus. The pancreas, gall bladder, and liver are also important components of the digestive system. That may sound like a lot to swallow, but you don’t have to be a scientist or a plumber to be familiar with the parts of your digestive system. As Sir Francis Bacon said back in the 16th century, “Knowledge is power.” In this case, knowledge is pooping power!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now that you know a little about the anatomy of your plumbing system, let’s take a closer look at how your pipes connect and work together. You may remember an old song about your bones: “The thigh bone’s connected to the knee bone,” etc. Just like your skeleton, everything in your digestive system is also connected (although part of it is pretty kinky), and each part has a specific function: to get the food you eat to pass from one section to another down the labyrinth of those 30 "), _c('span', {
    attrs: {
      "aria-label": "page 23",
      "id": "page_23",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("feet of intestines to the poop chute. The overall purpose of your digestive system is to transform the food you put in your body into rich nutrients that provide you with energy, cellular repair, and growth.")])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_20",
    attrs: {
      "alt": "Image",
      "src": "e9781646042845/images/f0023-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sb-head"
  }, [_vm._v("WITH PROFESSOR BUTTY’S HELP, LET’S START AT THE BEGINNING.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-para"
  }, [_vm._v("Even before you put food in your mouth, your sight and sense of smell have triggered your salivary glands to start the juices flowing in anticipation of enjoying the grub you will soon eat. Saliva helps with digestion, wets your mouth, reduces infection in your mouth and throat, and provides protection to your teeth and gums. Emotionally, you may feel elated, grateful, or even possessive of what you are about to consume. If you are with family or friends, the good food and company might spark a little laughter as you all prepare to partake in the shared culinary delights.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3x",
    attrs: {
      "id": "lev04"
    }
  }, [_vm._v("GUT-BRAIN CONNECTIONS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 24",
      "id": "page_24",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("During and after your meal, your central nervous system is sending and receiving messages of rich dialogue between the one hundred million (give or take a few thousand) nerve cells of your enteric nervous system (ENS), which is embedded in the walls of your gut and controls spontaneous movement of waste, blood flow, and nutrient absorption. Sympathetic nerves, part of the “autonomic,” or involuntary nervous system, act to accelerate your heart rate, slow down the muscle movement of your large intestine, constrict blood vessels, and increase wavelike contractions that move food along the digestive tract (a process called “peristalsis”). The sympathetic nerves in the esophagus branch out from the gut to the spinal cord, then on to the brain stem, which regulates your basic bodily functions.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The parasympathetic nerve network, sometimes called the “rest-and-digest nerves,” is also part of the autonomic system. It serves to counterbalance the sympathetic nerves by conserving energy while slowing your heart rate, increasing the activity of the intestines and glands, and allowing your sphincter muscles to efficiently facilitate peaceful, easy pooping.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These two nerve networks transmit signals to and from the brain stem via the vagus nerve from the colon. In one of his feeble attempts at humor, my anatomy and physiology professor in college told us that if we couldn’t find the vagus nerve on a "), _c('span', {
    attrs: {
      "aria-label": "page 25",
      "id": "page_25",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("chart of the human anatomy, we were required to call it the “lost vagus” nerve. All dad jokes aside, the vagus nerve is the most prominent pathway connecting the brain to the gut. In fact, it runs from the brain through the lungs, heart, spleen, liver, and kidneys all the way to the intestines and your microbiome, which you will soon learn about.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Both the gut and the brain utilize shared neurotransmitters, acetylcholine and neuropeptides (chemicals stimulating nerve signal transmissions), to send information back and forth. This bidirectional messaging system lets you know when you are full or, conversely, when anxiety curbs your appetite, as Ella experienced.")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_40",
    attrs: {
      "alt": "Image",
      "src": "e9781646042845/images/f0025-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 26",
      "id": "page_26",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("The diagram above will give you a better idea of this all-important bidirectional system.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3x",
    attrs: {
      "id": "lev05"
    }
  }, [_vm._v("YOUR PLUMBING SYSTEM")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now, back to the important way stations along your plumbing system. Once you put that first bite of food in your mouth, the average ten thousand taste buds on your tongue wake up and say, “Howdy-do!” which allows you to experience the unique flavors of food and drink: sweet, salty, sour, and bitter, as well as combinations of each.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chewing, combined with the enzymatic action of amylase and lingua lipase in your saliva, starts to break down the food. The amylase helps break down the starches (carbohydrates) into sugars, while the lipase breaks down the fats so your body can more easily absorb the food. The importance of chewing is often overlooked by eaters like Ella, who stuffs chunks of cinnamon roll in her mouth without thoroughly breaking it down, expecting the coffee to help it along. She’s lucky the partially chewed roll with the coffee chaser went down her throat to the esophagus, the muscular tube that delivers food to her stomach, rather than the “wrong pipe,” the windpipe. Unfortunately, we’ve all suffered the consequences of the repugnant regurgitative reactions that follow! Let’s take a look at the digestive system using the diagram here:")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 27",
      "id": "page_27",
      "role": "doc-pagebreak"
    }
  }, [_c('img', {
    staticClass: "portrait_70",
    attrs: {
      "alt": "Image",
      "src": "e9781646042845/images/f0027-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As you can easily see, the digestive system has many parts. I don’t want to get too academic here so I’ll do my best to keep it as clear as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 28",
      "id": "page_28",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "c2"
  }, [_vm._v("Station 1:")]), _vm._v(" The esophagus. Once you swallow your well-chewed food, it slides down the esophagus, where peristalsis moves it along toward the stomach. There’s a valve at the lower part of the esophagus called the esophageal sphincter (you see, it really is a plumbing system) that pushes the food into the stomach and keeps it from going backward in the wrong direction. (It can and does go backward when we’re sick and we upchuck, vomit, hurl…well, you get what I mean.) Once the food is in your stomach, the strong muscular lining holds it and does a bump and grind dance to mix it up. Your stomach secretes acid and powerful enzymes that continue to break the food down into a liquid-like paste until it passes into your small intestine.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "c2"
  }, [_vm._v("Station 2:")]), _vm._v(" The small intestine. Your small intestine is a very long, coiled tube in the abdomen. Amazingly, if it were spread out in a straight line, it would be about 20 feet long! Your small intestine continues the process of breaking down food using more enzymes released from the pancreas, along with bile from the liver and gallbladder. Bile helps with the digestion and absorption of fats and removes waste products from the blood. Again, peristalsis occurs in the small intestine, moving the food along as it mixes with digestive secretions. Important components of your small intestine continue to break down the food and eventually facilitate absorption of the nutrients into your bloodstream.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 29",
      "id": "page_29",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "c2"
  }, [_vm._v("Station 3:")]), _vm._v(" The gallbladder. This pear-shaped organ serves as a storage receptacle for the bile that comes from the liver through the hepatic duct. The gallbladder sends bile to the beginning of the small intestine called the duodenum via the common bile duct.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "c2"
  }, [_vm._v("Station 4:")]), _vm._v(" The large intestine. Your large intestine, or colon, is a muscular tube from 5 to 6 feet long, with a larger diameter than the small intestine. It has many interconnected parts, which I’ll break down separately below.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "e9781646042845/images/f0029-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sb-head"
  }, [_vm._v("BUTTY’S SIDENOTE")]), _vm._v(" "), _c('p', {
    staticClass: "sb-para"
  }, [_vm._v("We’ve got about 6 feet of intestine to go before we get to what I call the “poop chute,” or rectum. If this material is a bit dry for you, please drink plenty of water to stay hydrated because you’ll need it to cross the finish line!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "c2"
  }, [_vm._v("Station 5:")]), _vm._v(" The cecum (pronounced see-come). The first part of your colon is the cecum, a pouch-like structure at the juncture of the small and large intestines. The cecum "), _c('span', {
    attrs: {
      "aria-label": "page 30",
      "id": "page_30",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("acts as a reservoir for a pulpy, acidic fluid (called chyme and pronounced "), _c('i', [_vm._v("kime")]), _vm._v("), consisting of gastric juices and partially digested food that mix with the mucous lining in the walls of the cecum. The cecum also absorbs fluids and salts that remain after digestion in the small intestine.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "c2"
  }, [_vm._v("Stations 6 to 8:")]), _vm._v(" The ascending, transverse, and descending sections of the colon. After the cecum, your colon rises (ascending) from the right and crosses to the left side of your body (transverse section). From there it descends (descending section) and delivers waste down to the S-shaped (sigmoid) area that connects to the poop chute (rectum). Again, in all these sections, the process of peristalsis continues after the waste is delivered from the small intestine to the cecum.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "c2"
  }, [_vm._v("Station 9:")]), _vm._v(" The rectum. Your colon works to reabsorb fluids and process the waste to form stool that is stored in the S-shaped area until you feel (that is, if your plumbing system isn’t clogged) what I call “the Urge.” The Urge, or “mass movement,” occurs when there’s enough poop in the rectum to stretch and expand it. Once it is sufficiently stretched, the pelvic floor muscles of the anus, along with the two amazing anal sphincters, begin to do their magic. An angle between the rectum and the anus is created by the pelvic floor muscles, keeping poop from being expelled at the wrong time, like when we are sleeping. Thank goodness for that!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 31",
      "id": "page_31",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("When the poop reaches the internal anal sphincter, the defecation reflex kicks in, signaling the internal muscle of the anal sphincter to relax and the external anal sphincter (a skeletal muscle you have some control over) to contract. The finely tuned motor control of your pelvic floor muscles, along with the internal and external anal sphincter muscles usually (but not always) prevent us from the mess and embarrassment of pooping in our pants!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The end result of this exquisite network of living organic tissue in your gut-to-butt plumbing system is that when you reach the finish line, if you are in good poop health, you will experience the cathartic moment of release when the poop easily comes out of your wonderfully awesome anus. That’s when you truly feel the power of pooping!")]), _vm._v(" "), _c('h3', {
    staticClass: "h3x",
    attrs: {
      "id": "lev06"
    }
  }, [_vm._v("YOUR GUT IS THE HOME OF YOUR MICROBIOME")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You may or may not realize that I left out a mere forty trillion inhabitants of your gut, mostly residing in the cecum, the pouch at the beginning of your colon. Collectively, they are called your “gut microbiome.” No, they aren’t alien monsters that suddenly emerge from your belly and do a little dance. They are microscopic bacterial, viral, and fungal cells, or microbes that I call the “good gut guys,” as opposed to the “bad gut guys,” the bacteria that can make you sick. In reality, "), _c('span', {
    attrs: {
      "aria-label": "page 32",
      "id": "page_32",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("there are more microbial cells in your body than the approximately 30 trillion human cells.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And, according to the National Institutes of Health, there are as many as one thousand species of the good gut guys living in your body, all with different functions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If there were a way to collect all these good gut guys and put them on a scale, they might weigh anywhere from 2 to 5 pounds total! Working as a team, these good microbes act as an additional organ in your body and play a major role in your overall health.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4x",
    attrs: {
      "id": "lev01_sub01"
    }
  }, [_vm._v("WHO ARE THE GOOD GUT GUYS, AND WHAT DO THEY DO?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As humans have evolved over millions of years, the body has adapted to living with microbes. And microbes have come to play such a critical part in the health of our bodies that without them, we might not survive.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Your gut microbiome began to have an effect on your body the day you traversed your mother’s birth canal. Based on a 2017 "), _c('i', [_vm._v("Nature Medicine")]), _vm._v(" article, there is also evidence that babies come in contact with some microbes while still in the womb."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042845/xhtml/#footnote-021",
      "id": "footnote-021-backlink"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 33",
      "id": "page_33",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("After you were born and your body began to grow, your gut microbiome branched out, adding many varied species of microbes. The greater the diversity of these good gut guys, the healthier you tend to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Good gut bacteria help you digest fiber that produces short-chain fatty acids, contributing to the prevention of weight gain, heart disease, cancer, and diabetes. Your good gut guys also help regulate your immune system and respond to infections. Last but not least, a 2012 article in "), _c('i', [_vm._v("Nature Reviews Neuroscience")]), _vm._v(" found strong indications that your microbiome, via your central nervous system, may contribute to mood changes, anxiety, pain, and cognition as well as your overall brain health in response to stress."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042845/xhtml/#footnote-020",
      "id": "footnote-020-backlink"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3x",
    attrs: {
      "id": "lev07"
    }
  }, [_vm._v("THE HEALTHY HUMAN PLUMBING SYSTEM")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the first installment of Ella’s story (you guessed it, her story is far from over), you saw how poor choices of food and drink, coupled with a stressful lifestyle, created a cesspool in her clogged plumbing system. We know that an unhealthy gut can lead to a variety of diseases that include obesity, diabetes, depression, rheumatoid arthritis, and chronic fatigue. "), _c('span', {
    attrs: {
      "aria-label": "page 34",
      "id": "page_34",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("That begs the question: What does a healthy human plumbing system look like?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In order to promote a healthy gut, it’s important to have at least a basic understanding of how your plumbing system works.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a nutshell, your digestive system serves to break down liquids and foods into the chemical components of carbohydrates, fats, and proteins for your body to absorb using the extracted nutrients for energy, cell growth, and repair.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A healthy plumbing system produces beneficial digestive enzymes along with a rich, varied microbiome of the good gut guys to do the following effectively and efficiently:")]), _vm._v(" "), _c('ul', {
    staticClass: "blist"
  }, [_c('li', {
    staticClass: "bull"
  }, [_vm._v("absorb vital nutrients")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("prevent the growth of the bad gut guys that lead to disease")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("eliminate toxins and other foreign substances from the body")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you have a healthy digestive system, you process the food you eat in around\n    twenty-four to forty hours (depending on your plumbing system) and pass the waste material\n    easily and efficiently in one to two bowel movements of full-bodied, smooth stools per day. The\n    consistency, shape, and color of your stools are a reflection of your health—that includes your\n    diet, how hydrated you are, the medications you use, and "), _c('span', {
    attrs: {
      "aria-label": "page 35",
      "id": "page_35",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("possible medical conditions you may have. I will illustrate the types of healthy vs. unhealthy stools via "), _c('span', {
    attrs: {
      "href": "#/e9781646042845/xhtml/ch03#pg72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nurse Wong’s Poop Pictogram")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("It’s fascinating to me that over two thousand years ago, Hippocrates, the Greek physician, was onto something when he said, “all disease begins in the gut.” With the multitude of diet plans (some helpful, some just bad fads) overpopulating the internet, libraries, and bookstores, it’s no wonder people are confused as to what they need to do to foster a clean, well-functioning plumbing system. As your master plumber, I will provide simple tips to help you sort out what you can do to create a better life and healthier plumbing system through diet, lifestyle, and medical intervention, when necessary.")]), _vm._v(" "), _c('ol', {
    staticClass: "fnlist"
  }, [_c('li', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042845/xhtml/#footnote-023-backlink",
      "id": "footnote-023"
    }
  }, [_vm._v("1")]), _vm._v(". Oliver Heaviside, "), _c('i', [_vm._v("Electromagnetic Theory,")]), _vm._v(" vol. 2 (London: Electrician Printing and Publishing Co, 1899), 9.")]), _vm._v(" "), _c('li', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042845/xhtml/#footnote-022-backlink",
      "id": "footnote-022"
    }
  }, [_vm._v("2")]), _vm._v(". Jim Rohn, “The Treasury of Quotes,” Open Library, Health Communications, September 1, 1996, "), _c('a', {
    attrs: {
      "href": "https://openlibrary.org/books/OL8607826M/The_Treasury_of_Quotes",
      "target": "_blank"
    }
  }, [_vm._v("https://openlibrary.org/books/OL8607826M/The_Treasury_of_Quotes")]), _vm._v(", 49.")]), _vm._v(" "), _c('li', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042845/xhtml/#footnote-021-backlink",
      "id": "footnote-021"
    }
  }, [_vm._v("3")]), _vm._v(". Derrick M. Chu et al., “Maturation of the Infant Microbiome Community Structure and Function across Multiple Body Sites and in Relation to Mode of Delivery,” "), _c('i', [_vm._v("Nature Medicine")]), _vm._v(" 23, no. 3 (2017): 314–26, "), _c('a', {
    attrs: {
      "href": "https://doi.org/10.1038/nm.4272",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.1038/nm.4272")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042845/xhtml/#footnote-020-backlink",
      "id": "footnote-020"
    }
  }, [_vm._v("4")]), _vm._v(". John F. Cryan and Timothy G. Dinan, “Mind-Altering Microorganisms: The Impact of the Gut Microbiota on Brain and Behaviour,” "), _c('i', [_vm._v("Nature Reviews Neuroscience")]), _vm._v(", September 12, 2012, "), _c('a', {
    attrs: {
      "href": "https://doi.org/10.1038/nrn3346",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.1038/nrn3346")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2149265a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646042845/xhtml/ch01.vue
// module id = 75
// module chunks = 0